import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const StatsCard = ({ title, value, icon, color = 'purple', onClick }) => {
    const { isDark } = useTheme();

    const gradients = {
        purple: isDark
            ? 'linear-gradient(135deg, #7b2ff7 0%, #5b21b6 100%)'
            : 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
        cyan: isDark
            ? 'linear-gradient(135deg, #00d4ff 0%, #0891b2 100%)'
            : 'linear-gradient(135deg, #06b6d4 0%, #0e7490 100%)',
        green: isDark
            ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
            : 'linear-gradient(135deg, #34d399 0%, #10b981 100%)',
        orange: isDark
            ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
            : 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
        blue: isDark
            ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
            : 'linear-gradient(135deg, #60a5fa 0%, #2563eb 100%)',
        indigo: isDark
            ? 'linear-gradient(135deg, #6366f1 0%, #4338ca 100%)'
            : 'linear-gradient(135deg, #818cf8 0%, #4f46e5 100%)',
        red: isDark
            ? 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)'
            : 'linear-gradient(135deg, #f87171 0%, #dc2626 100%)',
        pink: isDark
            ? 'linear-gradient(135deg, #ec4899 0%, #be185d 100%)'
            : 'linear-gradient(135deg, #f472b6 0%, #db2777 100%)',
        yellow: isDark
            ? 'linear-gradient(135deg, #eab308 0%, #a16207 100%)'
            : 'linear-gradient(135deg, #facc15 0%, #ca8a04 100%)',
    };

    const styles = {
        card: {
            background: gradients[color],
            borderRadius: '1rem',
            padding: '1.5rem',
            color: 'white',
            cursor: onClick ? 'pointer' : 'default',
            transition: 'all 0.3s ease',
            boxShadow: isDark
                ? '0 4px 6px -1px rgba(0, 0, 0, 0.3)'
                : '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            minHeight: '140px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '1rem',
        },
        title: {
            fontSize: '0.875rem',
            fontWeight: 500,
            opacity: 0.9,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
        },
        icon: {
            fontSize: '2rem',
            opacity: 0.8,
        },
        value: {
            fontSize: '2.5rem',
            fontWeight: 'bold',
            lineHeight: 1,
        },
    };

    return (
        <div
            style={styles.card}
            onClick={onClick}
            onMouseEnter={(e) => {
                if (onClick) {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = isDark
                        ? '0 10px 15px -3px rgba(0, 0, 0, 0.4)'
                        : '0 10px 15px -3px rgba(0, 0, 0, 0.2)';
                }
            }}
            onMouseLeave={(e) => {
                if (onClick) {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = isDark
                        ? '0 4px 6px -1px rgba(0, 0, 0, 0.3)'
                        : '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                }
            }}
        >
            <div style={styles.header}>
                <div style={styles.title}>{title}</div>
                <div style={styles.icon}>{icon}</div>
            </div>
            <div style={styles.value}>{value}</div>
        </div>
    );
};

export default StatsCard;
